import styled from "styled-components"
import { withTranslation } from "react-i18next"
import { Button, Divider, Spin } from "antd";
import { useState } from "react";

import { post, get } from "library/endpoints";
import PaypalGiftcardPayment from "components/PaypalGiftcardPayment";

import Badges from "../Badges"
import { useEffect } from "react";
import useTheme from "hooks/useTheme";

const StyledBasketItem = styled.div`
  display: flex;

  .left {
    width: 300px;
    font-size: 15px;
    color: grey;

    div {
      margin-bottom: 3px;
    }

    .category {
      font-size: 18px;
      color: black;
    }

    span {
      color: black;
    }
  }

  .right {
    margin-left: auto;
    font-weight: 600;
    font-size: 18px;
    color: black;
  }
`;

/**
 * Badges
 * @param {*} props 
 * @returns 
 */
const Basket = (props) => {
  const [basket, setBasket] = useState(null)
  const { theme } = useTheme()


  useEffect(() => {
    // Create basket if not exists
    if (!basket) {
      createBasket()
    }
  }, []) // eslint-disable-line

  const createBasket = async () => {
    try {
      const response = await post(`frontend/giftcards/basket`, {
        category: props.userSelection.category,
        picture: props.userSelection.picture,
        amount: props.userSelection.amount,
        message: props.userSelection.message,
        user_from: props.userSelection.userFromName,
        user_to: props.userSelection.userToName,
        email: props.userSelection.email,
        to_email: props.userSelection.to_email,
        type: props.userSelection.type
      })

      setBasket(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  // const handleOnPayByStancer = async () => {
  //   try {
  //     const { data } = await post(`/frontend/payment/giftcard/stancer/${basket._id}`);
  //     if (data.checkout.url) {
  //       window.location.href = data.checkout.url;
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const handleOnPayByStripe = async () => {
    try {
      const { data } = await get(`/frontend/payment/giftcard/stripe/${basket._id}`);
      window.location.href = data.url;
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Badges 
        active={3}
        setCurrentView={props.setCurrentView}
      />

      <div style={{ color: '#333', textAlign: 'center', fontSize: 24, fontWeight: 700, marginBottom: 20 }}>Votre commande</div>

      <div style={{ paddingTop: 20, paddingBottom: 20, width: '90%', margin: 'auto', borderBottom: '1px dashed lightgrey' }}>
        <StyledBasketItem>
          <div className="left">
            <div className="category">{props.userSelection.category?.title || 'Montant personnalisé' }</div>
            <div>Votre nom : <span>{props.userSelection.userFromName}</span></div>
            <div>Votre Email : <span>{props.userSelection.email}</span></div>
            <div>Nom du destinataire : <span>{props.userSelection.userToName}</span></div>
            <div>Mail du destinataire : <span>{props.userSelection.to_email}</span></div>
            <div>Message : <span></span></div>
            <div><span>{props.userSelection.message}</span></div>

          </div>
          <div className="right">
            {props.userSelection.category?.amount || props.userSelection.amount}€
          </div>
        </StyledBasketItem>
      </div>

      <div style={{ paddingTop: 20, paddingBottom: 20, width: '90%', margin: 'auto', borderBottom: '1px dashed lightgrey' }}>
        <StyledBasketItem>
          <div className="left">
            <div className="category">Total :</div>
          </div>
          <div className="right" style={{ color: '#0097a7'}}>
            {props.userSelection.category?.amount || props.userSelection.amount}€
          </div>
        </StyledBasketItem>
      </div>

      {
        !theme ? (
          <Spin />
        ) : (
          <>
            {
              basket && (
                <div style={{ paddingTop: 20, paddingBottom: 20, width: '90%', margin: 'auto', borderBottom: '1px dashed lightgrey' }}>
                  <Button style={{ width: '100%', marginBottom: 10 }} onClick={handleOnPayByStripe} type="primary">Payer par carte bancaire</Button>

                  {
                    theme.clientID && theme.clientID !== '' && (
                      <>
                        <Divider>ou</Divider>
                        <PaypalGiftcardPayment 
                          userSelection={props.userSelection}
                          basket={basket}
                        />
                      </>
                    )
                  }
                </div>
              )
            }
          </>
        )
      }
    </>
  )
}

export default withTranslation()(Basket)